import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ProviderLogo from '~/components/Shared/ProviderLogo/ProviderLogo';
import { Divider } from '~/eds/src/components/Divider/Divider';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { ManageSyncPairStageType } from '~/enums/ManageSyncPairStageType';
import { useIntl } from 'react-intl';
import { slices } from '~/redux/slices';

import AribaFooter from '../AribaFooter';
import FieldMapping from './FieldMapping';

function FieldMappingSetup() {
  const intl = useIntl();
  const dispatch = useDispatch();
  const activeSyncPair = useSelector(
    slices.integrations.selectors.selectActiveSyncPair,
  );
  const manageSyncPairStage = useSelector(
    slices.integrations.selectors.selectManageSyncPairStage,
  );
  const { provider } = activeSyncPair;
  const areAllFieldsMapped =
    activeSyncPair[manageSyncPairStage]?.areAllFieldsMapped;

  const mainActionDisabled = useMemo(() => {
    if (!areAllFieldsMapped) {
      return true;
    }
  }, [areAllFieldsMapped]);

  const handleBack = () => {
    dispatch(
      slices.integrations.actions.setManageSyncPairStage(
        ManageSyncPairStageType.FolderAriba,
      ),
    );
  };

  const handleCreateNext = () => {
    dispatch(
      slices.integrations.actions.setManageSyncPairStage(
        ManageSyncPairStageType.SummaryAriba,
      ),
    );
  };

  return (
    <Layout align="center" direction="column" spacing={8} w="100%">
      <Layout align="center">
        <ProviderLogo provider={provider} />
      </Layout>
      <Divider />
      <Layout preset="form-fields">
        <FieldMapping />
      </Layout>
      <AribaFooter
        secondaryAction={{
          text: intl.formatMessage({
            id: 'FieldMappingSetup.backButton',
            defaultMessage: 'Back',
            description: 'Button text for going back',
          }),
          onClick: handleBack,
        }}
        mainAction={{
          text: intl.formatMessage({
            id: 'FieldMappingSetup.nextButton',
            defaultMessage: 'Next',
            description: 'Button text for proceeding to next step',
          }),
          onClick: handleCreateNext,
          disabled: mainActionDisabled,
        }}
      />
    </Layout>
  );
}

export default FieldMappingSetup;
